import { FBase } from "./firebase.base";
import { isObject } from "@pineapplelab/util";
import { IsEmail, IsAlpha, IsNumeric, IsOptional} from "@pineapplelab/validators";
import { Paging } from "../paging";


export class User extends FBase {
  id: string = null;
  @IsAlpha({label: 'First Name'}) firstName: string = null;
  @IsAlpha({label: 'Last Name'}) lastName: string = null;
  @IsEmail({label: 'Email'}) email: string = null;
  username: string = null;
  clientId: string = null;
  /** FK to the ClientContact this client-portal identity was provisioned from. */
  contactId: string = null;
  isApproved: boolean = null;
  isClientUser: boolean = null;
  isGuestUser: boolean = null;
  @IsOptional()
  @IsNumeric({label: 'Phone'}) phone: string = null;
  /** Denormalized role names — camelCase stored in users/{uid}.roleNames */
  roleNames: string[] = null;
  /** Denormalized role IDs — camelCase stored in users/{uid}.roleIds */
  roleIds: string[] = null;
  constructor(json?: { [key: string]: any }) {
    super();
    if (isObject(json)) {
      this.fromJson(json);
    }
  }

  getName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}

export namespace User {
  export const PATH = 'users';
  export const PAGING = new Paging<User>( <Paging.IPaging>{
    collection: PATH,
    orderOptions: [
      { field: 'firstName', label: 'First Name', placeholder: 'Filter by first name', dataType: Paging.dataType.string },
      { field: 'active', label: 'Active', placeholder: 'Filter by first status', dataType: Paging.dataType.string }
    ],
    orderBy: 'firstName'
  } );
}
